import { StrictMode, lazy } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import * as Tooltip from '@radix-ui/react-tooltip'
import './styles/index.css'
import { Layout } from './components/Layout'
import { useApp } from './lib/store'

document.documentElement.dataset.theme = useApp.getState().theme

const Landing = lazy(() => import('./pages/Landing'))
const Atlas = lazy(() => import('./pages/Atlas'))
const FacilityPage = lazy(() => import('./pages/Facility'))
const StatePage = lazy(() => import('./pages/State'))
const Inside = lazy(() => import('./inside/InsidePage'))
const Prompt = lazy(() => import('./inside/PromptStory'))
const Learn = lazy(() => import('./pages/Learn'))
const Voices = lazy(() => import('./pages/Voices'))
const Portal = lazy(() => import('./portal/Portal'))
const PortalFacility = lazy(() => import('./portal/PortalFacility'))
const Review = lazy(() => import('./portal/Review'))
const Magic = lazy(() => import('./portal/Magic'))
const Moderate = lazy(() => import('./portal/Moderate'))
const Sources = lazy(() => import('./pages/Sources'))
const Methodology = lazy(() => import('./pages/Methodology'))
const About = lazy(() => import('./pages/About'))
const NotFound = lazy(() => import('./pages/NotFound'))

const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      { path: '/', element: <Landing /> },
      { path: '/map', element: <Atlas /> },
      { path: '/facility/:slug', element: <FacilityPage /> },
      { path: '/state/:code', element: <StatePage /> },
      { path: '/inside', element: <Inside /> },
      { path: '/inside/prompt', element: <Prompt /> },
      { path: '/learn', element: <Learn /> },
      { path: '/learn/:topic', element: <Learn /> },
      { path: '/voices', element: <Voices /> },
      { path: '/portal', element: <Portal /> },
      { path: '/portal/magic', element: <Magic /> },
      { path: '/portal/facility/:slug', element: <PortalFacility /> },
      { path: '/portal/review/:id', element: <Review /> },
      { path: '/moderate', element: <Moderate /> },
      { path: '/sources', element: <Sources /> },
      { path: '/methodology', element: <Methodology /> },
      { path: '/about', element: <About /> },
      { path: '*', element: <NotFound /> },
    ],
  },
])

const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 5 * 60_000, retry: 1, refetchOnWindowFocus: false } } })

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <Tooltip.Provider delayDuration={200}>
        <RouterProvider router={router} />
      </Tooltip.Provider>
    </QueryClientProvider>
  </StrictMode>,
)
